import styled from 'styled-components';

export const StyledHomepage = styled.div`
    max-width: 950px;
    margin: 50px auto;
    background-color: var(--off-white);

    @media screen and (max-width: 980px) {
        width: 90%;
    }
`;